import { render, staticRenderFns } from "./accordionItem.vue?vue&type=template&id=173cb3fe"
import script from "./accordionItem.vue?vue&type=script&lang=js"
export * from "./accordionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports